// Is a stored, hand-entered URL safe to use as an OUTBOUND href?
//
// ⚠️ Only an ABSOLUTE http(s) URL qualifies. A stored "facebook.com/x" used as
// an href is a RELATIVE path — it navigates inside kyck rather than out to
// Facebook, which reads as the app breaking rather than as a bad setting. A
// `javascript:` or `data:` value is refused for the obvious reason.
//
// Lifted out of googleAdsAccountLink.ts (2026-09-30) when the per-account
// external link icons needed the same check, so the two cannot drift.
export function isAbsoluteHttpUrl(url: string | null | undefined): boolean {
  const raw = (url ?? '').trim();
  if (raw === '') return false;
  try {
    const parsed = new URL(raw);
    return parsed.protocol === 'https:' || parsed.protocol === 'http:';
  } catch {
    return false;
  }
}
